export default __webpack_public_path__ + "static/media/aftermembership.f309c21f.jpg";